module.exports = __webpack_public_path__ + "zilla-slab-latin-600.533a79ea86b26f3f2bb01ae65284bc61.woff";